import { Component, Input, OnInit } from '@angular/core';
import { Covering, Lining } from '../../lining-and-covering';
import { LiningAndCoveringService } from '../../lining-and-covering.service';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Project } from '../../project';
import { WarehouseParamsFormService } from '../warehouse-params-forms/warehouse-params-form.service';
import { CintacValidators } from '../../../_shared/cintac-validators';
import { Warehouse } from '../../warehouse';

@Component({
  selector: 'app-linings-and-loads',
  templateUrl: './linings-and-loads.component.html',
  styleUrls: ['../project-form.css']
})
export class LiningsAndLoadsComponent implements OnInit {
  linings: Map<string, Lining>;
  coverings: Map<string, Covering>;
  loadsAndLiningsData: AbstractControl;
  windConditions = Warehouse.getWindConditions();
  rs = Warehouse.getRs();

  @Input() project: Project;

  validationMessages = {
    'covering': {
      'required': 'Ingresar una cubierta.',
    },
    'has_lateral_lining': {
      'required': 'Ingresar si hay revestimiento lateral.',
    },
    'lateral_lining': {
      'required': 'Ingresar revestimiento lateral.',
    },
    'has_front_lining': {
      'required': 'Ingresar si hay revestimiento frontal.',
    },
    'front_lining': {
      'required': 'Ingresar revestimiento frontal.',
    },
    'wind_condition': {
      'required': 'Ingresar condición de viento.',
      'listValidator': CintacValidators.getWindCondValidatorMessage()
    },
    'has_door': {
      'required': 'Ingresar valores de ancho y de altura del porton.',
    },
    'pp': {
      'required': 'Ingresar valor para peso propio.',
    },
    'a': {
      'required': 'Ingresar porcentaje de masa sísmica aportada por carga viva.',
    },
    'rfactor': {
      'required': 'Ingresar factor de modificación de respuesta.',
    },
    'latitude': {
      'required': 'Ingresar valor de latitud.',
    },
    'altitude': {
      'required': 'Ingresar valor de altitud.',
    }

  };

  formErrors = {
    'covering': '',
    'has_lateral_lining': '',
    'lateral_lining': '',
    'has_front_lining': '',
    'front_lining': '',
    'wind_condition': '',
    'has_door': '',
    'pp': '',
    'a': '',
    'rfactor': '',
    'latitude': '',
    'altitude': '',
  };

  constructor(private elementService: LiningAndCoveringService,
    private fb: FormBuilder,
    private warehouseFormService: WarehouseParamsFormService) {
    this.loadsAndLiningsData = this.fb.group({
      covering: ['', [Validators.required]],
      has_lateral_lining: [true, [Validators.required]],
      lateral_lining: ['', []],
      has_front_lining: [true, [Validators.required]],
      front_lining: ['', []],
      wind_condition: [null, [Validators.required, CintacValidators.windCondValidator]],
      opening_height: [0, []],
      opening_width: [0, []],
      has_hb: [null, [Validators.required]],
      has_door: ['', [Validators.required]],
      pp: ['', [Validators.required]],
      a: ['', [Validators.required]],
      rfactor: ['', [Validators.required]],
      latitude: ['', [Validators.required]],
      altitude: ['', [Validators.required]],
    });
    this.linings = new Map();
    this.coverings = new Map();
  }

  ngOnInit() {
    this.elementService.getCoverings().subscribe((coverings) => {
      for (const covering of coverings) {
        this.coverings.set(covering.id + '', covering);
      }
    });
    this.elementService.getLinings().subscribe((linings) => {
      for (const lining of linings) {
        this.linings.set(lining.id + '', lining);
      }
    });

    this.loadsAndLiningsData.patchValue({
      covering: this.project.warehouse.covering,
      has_lateral_lining: this.project.warehouse.has_lateral_lining,
      lateral_lining: this.project.warehouse.lateral_lining,
      has_front_lining: this.project.warehouse.has_front_lining,
      front_lining: this.project.warehouse.front_lining,
      wind_condition: this.project.warehouse.wind_condition,
      opening_height: this.project.warehouse.opening_height,
      opening_width: this.project.warehouse.opening_width,
      has_hb: this.project.warehouse.has_hb,
      has_door: (this.project.warehouse.opening_height == 0 || this.project.warehouse.opening_width == 0) ? false : true,
      pp: this.project.warehouse.pp,
      a: this.project.warehouse.a,
      rfactor: this.project.warehouse.rfactor,
      latitude: this.project.warehouse.latitude,
      altitude: this.project.warehouse.altitude,
    });
    this.loadsAndLiningsData.valueChanges.subscribe(values => this.onValueChanged());

  }

  onValueChanged() {
    this.warehouseFormService.updateFormMessages(this.loadsAndLiningsData, this.formErrors, this.validationMessages);

    if (this.loadsAndLiningsData.value.has_lateral_lining &&
      this.loadsAndLiningsData.value.lateral_lining === null) {
      this.formErrors.lateral_lining = this.validationMessages.lateral_lining.required;
    }

    if (this.loadsAndLiningsData.value.has_front_lining &&
      this.loadsAndLiningsData.value.front_lining === null) {
      this.formErrors.front_lining = this.validationMessages.front_lining.required;
    }

    if (this.loadsAndLiningsData.value.has_door &&
      this.loadsAndLiningsData.value.opening_width === 0 || this.loadsAndLiningsData.value.opening_height === 0) {
      this.formErrors.has_door = this.validationMessages.has_door.required;
    }

    if (!this.loadsAndLiningsData.value.has_lateral_lining) {
       this.loadsAndLiningsData.value.lateral_lining = null;
       this.loadsAndLiningsData.value.has_front_lining = false;
    }
    if (!this.loadsAndLiningsData.value.has_front_lining) {
       this.loadsAndLiningsData.value.front_lining = null;
    }
    if (this.loadsAndLiningsData.value.has_lateral_lining && !this.loadsAndLiningsData.value.has_door) {
        this.loadsAndLiningsData.patchValue({
            has_door: true,
        });
    }

    if ((!this.loadsAndLiningsData.value.has_front_lining ||
        !this.loadsAndLiningsData.value.has_door) &&
        (this.loadsAndLiningsData.value.opening_width !== 0 ||
        this.loadsAndLiningsData.value.opening_height !== 0)) {
      this.loadsAndLiningsData.patchValue({
        opening_height: 0,
        opening_width: 0,
      });
    }
    this.updateWarehouse();
  }

  updateWarehouse() {
    this.project.warehouse.covering = this.loadsAndLiningsData.value.covering;
    this.project.warehouse.has_lateral_lining = this.loadsAndLiningsData.value.has_lateral_lining;
    this.project.warehouse.lateral_lining = this.loadsAndLiningsData.value.lateral_lining;
    this.project.warehouse.has_front_lining = this.loadsAndLiningsData.value.has_front_lining;
    this.project.warehouse.front_lining = this.loadsAndLiningsData.value.front_lining;
    this.project.warehouse.wind_condition = this.loadsAndLiningsData.value.wind_condition;
    this.project.warehouse.opening_height = this.loadsAndLiningsData.value.opening_height;
    this.project.warehouse.opening_width = this.loadsAndLiningsData.value.opening_width;
    this.project.warehouse.has_hb = this.loadsAndLiningsData.value.has_hb;
    this.project.warehouse.pp = this.loadsAndLiningsData.value.pp;
    this.project.warehouse.a = this.loadsAndLiningsData.value.a;
    this.project.warehouse.rfactor = this.loadsAndLiningsData.value.rfactor;
    this.project.warehouse.latitude = this.loadsAndLiningsData.value.latitude;
    this.project.warehouse.altitude = this.loadsAndLiningsData.value.altitude;
  }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/linings-and-loads/linings-and-loads.component.ts